// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popup":"popup_3vNif"};